module.exports = __webpack_public_path__ + "fonts/righthand-italic-personal.9cc9610a.ttf";